import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IEstimationChartData } from '../../types/redux/estimationChart';

export enum EActionTypes {
  Request = 'estimation_chart/request',
  Success = 'estimation_chart/success',
  Failure = 'estimation_chart/failure',
}

export const requestAction = actionGenerator<EActionTypes.Request>(EActionTypes.Request);
export const successAction = actionGenerator<EActionTypes.Success, IEstimationChartData | null>(EActionTypes.Success);
export const failureAction = actionGenerator<EActionTypes.Failure>(EActionTypes.Failure);

export type TGetEstimationChartRequest = ReturnType<typeof requestAction>;
export type TGetEstimationChartSuccess = ReturnType<typeof successAction>;
export type TGetEstimationChartFailure = ReturnType<typeof failureAction>;

export type TGetEstimationChartActions =
  | TGetEstimationChartRequest
  | TGetEstimationChartSuccess
  | TGetEstimationChartFailure;
